import { render, staticRenderFns } from "./ModifyTerminal.vue?vue&type=template&id=0771904e&scoped=true"
import script from "./ModifyTerminal.vue?vue&type=script&lang=js"
export * from "./ModifyTerminal.vue?vue&type=script&lang=js"
import style0 from "./ModifyTerminal.vue?vue&type=style&index=0&id=0771904e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0771904e",
  null
  
)

export default component.exports